export const makeEnvironmentUrl = url => {
  if (!url) return '/dashboard';

  const isLocalEnv = process.env.REACT_APP_MODE === 'local' || process.env.REACT_APP_MODE === 'homolog';

  // páginas aspx continuam iguais
  if (/\.aspx$/i.test(url)) return url;

  // se já é rota
  if (url.startsWith('/')) return url;

  try {
    const parsed = new URL(url);

    // em local/homolog usamos apenas o path
    if (isLocalEnv) {
      return parsed.pathname || '/dashboard';
    }

    // produção mantém url completa
    return url;
  } catch {
    return '/dashboard';
  }
};
